import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VDivider,
  VSubheader,
  VSelect,
  VAvatar,
  VDialog,
  VCard,
  VTextField,
  VProgressCircular,
  VRadioGroup,
  VSnackbar,
  VAlert,
  VCheckbox,
  VSlider,
  transitions
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VDivider,
    VSubheader,
    VSelect,
    VAvatar,
    VDialog,
    VCard,
    VTextField,
    VProgressCircular,
    VRadioGroup,
    VSnackbar,
    VAlert,
    VCheckbox,
    VSlider,
    transitions
  }
})
